import {useState} from 'react';
import {UserCreditCardsDTO} from '../../../../../dtos/UserCreditCardsDTO';

export type PaymentMethod = 'PIX' | 'TICKETLOG' | UserCreditCardsDTO | null;

export interface PaymentMethodState {
  selectedPaymentMethod: PaymentMethod;
  changePaymentMethod: (method: PaymentMethod) => void;
}

export function usePaymentMethod(): PaymentMethodState {
  const [selectedPaymentMethod, setSelectedPaymentMethod] =
    useState<PaymentMethod>(null);

  return {
    selectedPaymentMethod,
    changePaymentMethod: setSelectedPaymentMethod,
  };
}
